import gql from 'graphql-tag';

export const SEARCH_LOCATION_QUERY = gql`
    query SearchLocation($query: String!, $limit: Int) {
        searchLocation(query: $query, limit: $limit) {
            label
            placeId
        }
    }
`;
